import request from '@wearetla/tla-essentials-tools/utilities/request';
import omit from 'lodash/omit';
import { createI18nInstance } from '/utilities/i18n';

// Functions
import formatDate from '/functions/format-date';

const getT = () => createI18nInstance().t;

const menuServices = {
	getBranchMenu: (branchSlug) => {
		const t = getT();

		return new Promise((resolve, reject) => {
			request.get(`menu/branch/${branchSlug}`, false, (payload, status, request) => {
				if (payload?.categories) {
					resolve(payload.categories);
				} else {
					reject(
						request?.data?.meta?.messages ||
							t('Menü getirilirken bir hata ile karşılaşıldı, lütfen tekrar dene.')
					);
				}
			});
		});
	},
	getMenuCategories: (branchSlug) => {
		const t = getT();

		return new Promise((resolve, reject) => {
			request.get(`menu/branch/${branchSlug}`, false, (payload, status, request) => {
				if (payload?.menu?.merchants?.[0]) {
					resolve(
						payload.menu.merchants[0].menus.reduce((payload, menu) => {
							if (menu.products.length) {
								return [
									...payload,
									{
										...omit(menu, ['products']),
										product_count: menu.products?.length ?? 0,
									},
								];
							}

							return payload;
						}, [])
					);
				} else {
					reject(
						request?.data?.meta?.messages ||
							t('Menü getirilirken bir hata ile karşılaşıldı, lütfen tekrar dene.')
					);
				}
			});
		});
	},
	getMenuCategory: (branchSlug, categoryId) => {
		const t = getT();

		return new Promise((resolve, reject) => {
			request.get(`menu/branch/${branchSlug}`, false, (payload, status, request) => {
				const menuCategory = (payload.menu?.merchants?.[0]?.menus ?? []).find(
					(menu) => menu.id.toString() === categoryId.toString()
				);
				if (menuCategory) {
					resolve({

						updated_at: payload.menu.merchants[0].updated_at,
						updated_at_formatted: formatDate(payload.menu.merchants[0].updated_at),
						...menuCategory
					});
				} else {
					reject(
						request?.data?.meta?.messages ||
							t('Menü getirilirken bir hata ile karşılaşıldı, lütfen tekrar dene.')
					);
				}
			});
		});
	},
	getMenuProduct: (productId) => {
		const t = getT();

		return new Promise((resolve, reject) => {
			request.get(`menu/product/${productId}`, false, (payload, status, request) => {
				if (payload?.merchant_menu_product) {
					resolve({
						...payload.merchant_menu_product,
						category: payload.merchant_menu,
					});
				} else {
					reject(
						request?.data?.meta?.messages ||
							t('Ürün getirilirken bir hata ile karşılaşıldı, lütfen tekrar dene.')
					);
				}
			});
		});
	},
	getMenuSearchResults: (branchSlug, query) => {
		const t = getT();

		return new Promise((resolve, reject) => {
			request.get(`menu/branch/${branchSlug}/products`, { query }, (payload, status, request) => {
				if (payload?.menu) {
					resolve({
						query,
						results: payload.menu,
					});
				} else {
					reject(
						request?.data?.meta?.messages ||
							t('Arama sonuçları getirilirken bir hata ile karşılaşıldı, lütfen tekrar dene.')
					);
				}
			});
		});
	},
};

export default menuServices;
